import { Workflow } from 'lucide-preact';
import { MonthRangeSlider, SankeyChart } from '../../components/charts';
import type { SankeyLink, SankeyNode } from '../../components/charts/SankeyChart';
import type { MonthOption, MonthRangeValue } from '../../components/charts/MonthRangeSlider';
import { ChartCard, EmptyState, LoadingState } from '../../components/ui';

interface UnitCashflowSectionProps {
  unitCurrency: string;
  loading: boolean;
  monthsAsc: MonthOption[];
  range: MonthRangeValue;
  nodes: SankeyNode[];
  links: SankeyLink[];
  onRangeChange: (startId: string, endId: string) => void;
}

export function UnitCashflowSection({
  unitCurrency,
  loading,
  monthsAsc,
  range,
  nodes,
  links,
  onRangeChange,
}: UnitCashflowSectionProps) {
  return (
    <ChartCard
      title="Cash Flow Overview"
      icon={<Workflow size={16} strokeWidth={2} />}
      className="unit-cashflow-card"
      controls={
        !loading && monthsAsc.length > 0 ? (
          <MonthRangeSlider
            months={monthsAsc}
            value={range}
            onChange={onRangeChange}
          />
        ) : undefined
      }
    >
      {loading ? (
        <LoadingState message="Loading cash flow…" />
      ) : monthsAsc.length === 0 ? (
        <EmptyState message="No cash flow data available" />
      ) : (
        <div className="unit-cashflow-chart">
          <SankeyChart
            nodes={nodes}
            links={links}
            title=""
            height="100%"
            width="100%"
            currencyCode={unitCurrency}
            className="unit-cashflow-sankey"
          />
        </div>
      )}
    </ChartCard>
  );
}
